import React from 'react'

class Main extends React.Component {
    render() {
        return(
            <div className='main-wrapper'>
                <div className='main'> 
                    <div className='copy-container'>
                        <h1>アニメ手帳</h1>
                        <h2>アニメ手帳はあなたの見ているアニメを管理するアプリケーションです！</h2>
                        <p class="screenshot"> 
                            <img src='app-screenshot1.png'/>
                            <img src='app-screenshot2.png'/>
                        </p>
                    </div>
                    <div className='lesson-container'>
                        <h3 className='section-title'>関連アプリ</h3>
                        <a href="https://apps.apple.com/jp/app/%E4%BB%8A%E5%AD%A3%E3%81%AE%E3%82%A2%E3%83%8B%E3%83%A1%E3%82%92%E4%B8%80%E6%8B%AC%E7%AE%A1%E7%90%86-%E3%82%A2%E3%83%8B%E3%83%A1%E6%89%8B%E5%B8%B3/id1556976347" target="_blank">
                            <div className='lesson-card'>
                                <div className='lesson-item'>
                                    <img src='https://github.com/harumidiv/AnimeSchedulePrivacyPolicy/blob/master/180.png?raw=true' />
                                    <p>アニメ手帳</p>
                                </div>
                                <img src='AppleStore-icon.svg' />
                            </div>
                        </a>
                        <a href="https://apps.apple.com/jp/app/toio-%E3%82%B3%E3%83%B3%E3%83%88%E3%83%AD%E3%83%BC%E3%83%A9%E3%82%A2%E3%83%97%E3%83%AA/id1469030441" target="_blank">
                            <div className='lesson-card'>
                                <div className='lesson-item'>
                                    <img src='https://github.com/harumidiv/toio-controller/blob/master/ToioController/Assets.xcassets/AppIcon.appiconset/180.png?raw=true' />
                                    <p>toio controller</p>
                                </div>
                                <img src='AppleStore-icon.svg' />
                            </div>
                        </a>
                        <a href="https://apps.apple.com/jp/app/oh-natto-%E7%B4%8D%E8%B1%86%E3%83%8D%E3%83%90%E3%83%8D%E3%83%90%E3%82%B7%E3%83%9F%E3%83%A5%E3%83%AC%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3/id1457049172" target="_blank">
                            <div className='lesson-card'>
                                <div className='lesson-item'>
                                    <img src='https://github.com/inouefood/oh-natto/blob/master/natto/Assets.xcassets/AppIcon.appiconset/Icon-App-60x60@3x.png?raw=true' />
                                    <p>oh! natto!</p>
                                </div>
                                <img src='AppleStore-icon.svg' />
                            </div>
                        </a>
                        <a href="https://apps.apple.com/jp/app/rubi/id1471085589" target="_blank">
                            <div className='lesson-card'>
                                <div className='lesson-item'>
                                    <img src='https://github.com/harumidiv/Rubi/blob/master/Rubi/Resource/Assets.xcassets/AppIcon.appiconset/180.png?raw=true' />
                                    <p>Rubi</p>
                                </div>
                                <img src='AppleStore-icon.svg' />
                            </div>
                        </a>
                        <a href="https://apps.apple.com/jp/app/%E3%81%88%E3%81%B3%E3%83%95%E3%83%A9%E3%82%A4/id1461666071" target="_blank">
                            <div className='lesson-card'>
                                <div className='lesson-item'>
                                    <img src='https://github.com/inouefood/ebiFly/blob/master/ebiFly/Assets.xcassets/AppIcon.appiconset/180.png?raw=true' />
                                    <p>えびフライ</p>
                                </div>
                                <img src='AppleStore-icon.svg' />
                            </div>
                        </a>
                        <a href="https://apps.apple.com/jp/app/%E3%81%A0%E3%82%8C%E3%81%AE%E3%81%82%E3%81%97-%E8%84%B3%E3%83%88%E3%83%ACiq%E8%AC%8E%E8%A7%A3%E3%81%8D%E8%B6%B3%E3%82%AF%E3%82%A4%E3%82%BA%E3%82%A2%E3%83%97%E3%83%AA/id1465352189" target="_blank">
                            <div className='lesson-card'>
                                <div className='lesson-item'>
                                    <img src='https://github.com/harumidiv/WhoLeg/blob/master/WhoLeg/Assets.xcassets/AppIcon.appiconset/180.png?raw=true' />
                                    <p>だれのあし</p>
                                </div>
                                <img src='AppleStore-icon.svg' />
                            </div>
                        </a>
                        <a href="https://apps.apple.com/jp/app/%E3%82%80%E3%81%AB%E3%82%85/id1461761608" target="_blank">
                            <div className='lesson-card'>
                                <div className='lesson-item'>
                                    <img src='https://github.com/harumidiv/Munyu/blob/master/Munyu/Munyu/Assets.xcassets/AppIcon.appiconset/180.png?raw=true' />
                                    <p>むにゅ</p>
                                </div>
                                <img src='AppleStore-icon.svg' />
                            </div>
                        </a>
                    </div>
                </div>
             </div>
        );
    }
}

export default Main;
